/**
 * Human-readable labels for suggestion reasons.
 * Shared between SuggestionBubbleMenu (for DELETE_TEXT_RANGE) and
 * SuggestionPopover (for DELETE_SEGMENT).
 */
export const REASON_LABELS: Record<string, string> = {
  // DELETE_SEGMENT reasons
  DUPLICATE_PRIOR_SEGMENTS: "Duplicate of prior segment",
  MISC_NOT_USEFUL: "Not useful",
  IRRELEVANT_BODY_PARTS: "Irrelevant body parts",
  OUTSIDE_SPECIALTY_PANEL: "Outside specialty / panel",
  // DELETE_TEXT_RANGE reasons
  DUPLICATE_WITHIN_SEGMENT: "Duplicate within segment",
  IRRELEVANT_INFORMATION: "Irrelevant information",
  DUPLICATE_IN_ANOTHER_SEGMENT: "Previously mentioned information",
  EXISTING_INFORMATION: "Already stated elsewhere",
  NO_ADDITIONAL_INSIGHT: "No additional insight",
  REDUNDANT_CLINICAL_DETAIL: "Redundant clinical detail",
};

/**
 * Get human-readable label for a suggestion reason.
 * Falls back to the raw reason string if no label is found.
 */
export function getReasonLabel(reason: string): string {
  return REASON_LABELS[reason] || reason;
}
